import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { IconMenuKebab } from '@prisjakt/ui/icon';
import { MediumUp, MobileOnly } from 'src/ui/block';

import * as S from './styles';

interface IExpandButton {
  expanded?: boolean;
  onClick?: () => void;
  title?: string;
}

export const ExpandButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IExpandButton>
>> = ({ expanded = false, onClick, title }) => {
  const {
    isFeatured,
    newOfferItemExperiment,
    showExpandButton,
  } = usePriceRowContext();

  const getColor = () => {
    if (isFeatured && !newOfferItemExperiment) return 'maybeBlue700';
    if (isFeatured && newOfferItemExperiment) return 'base800';
    if (!isFeatured && newOfferItemExperiment) return 'base600';
    return 'base500';
  };

  return (
    <S.ExpandButton
      type="button"
      aria-label={title}
      onClick={onClick}
      data-test="ExpandButton"
      $expanded={expanded}
      $hidden={!showExpandButton}
      $newOfferItemExperiment={Boolean(newOfferItemExperiment)}
    >
      <MobileOnly>
        <IconMenuKebab
          color={getColor()}
          size={newOfferItemExperiment ? 19 : 24}
        />
      </MobileOnly>
      <MediumUp>
        <IconMenuKebab color="maybeBlue700" size={24} />
      </MediumUp>
    </S.ExpandButton>
  );
};
